import { render, staticRenderFns } from "./EmdLoader.vue?vue&type=template&id=8244eac8&"
import script from "./EmdLoader.vue?vue&type=script&lang=js&"
export * from "./EmdLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports